<template>
    <div class="pg-product-list">
        <header class="">
            <div class="toptitle">
                <h1>{{ queryStr.searchType == 0 ? queryStr.searchName : queryStr.cateName }}</h1>
                <div class="header-right" style="flex: 2">
                    <span>
                        当前分类下共有<em>{{ counts }}</em>个产品
                    </span>
                </div>
            </div>
            <div class="tabs" v-show="tabsName.length > 0">
                <!-- <div class="swiper-container" v-swiper:mySwiper="swiperOption" >
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <a href="javasciprt: void(0);" :class="{active:tabIdx==0}" @click="tabHandle(0)">全部</a>
                    </div>
                    <div class="swiper-slide" v-for="(tabItem,index) in tabsName" :key="tabItem.id">
                        <a href="javasciprt: void(0);" :class="{active:tabIdx==index+1}" @click="tabHandle(index+1, tabItem)">{{tabItem.name}}</a>
                    </div>
                </div>
            </div> -->

                <swiper :options="swiperOption" ref="mySwiper">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in ['全部', '其他']" :key="index">
                        <div @click="tabHandle(index)">{{ item }}</div>
                    </swiper-slide>
                </swiper>
            </div>
        </header>

        <div class="list" :class="{ fixtab2: tabsName.length <= 0 }" id="product-list">
            <ul>
                <li v-for="product in productList" :key="product.pId">
                    <router-link :to="{ path: '/prodetail', query: { id: product.pId } }">
                        <div class="img-wrapper">
                            <img :src="imgHost + product.pImg" alt="" v-if="product.pImg" />
                            <img src="../../assets/images/goods-default.png" alt="" v-else />
                        </div>
                        <div class="item-right">
                            <h3>{{ product.pName }}</h3>
                            <p>
                                <span>生产商:{{ product.munAbb }}</span>
                            </p>
                            <p>
                                <span>牌号：{{ product.grade }}</span>
                            </p>
                        </div>
                    </router-link>
                </li>
                <li class="nomore">{{ loadtips }}</li>
            </ul>
        </div>
        <div class="ctrls">
            <router-link to="/"><img src="../../assets/images/home.png" alt="返回首页" /></router-link>
            <transition name="fade">
                <span v-show="backTopShow"><img src="../../assets/images/top.png" alt="回到顶部"
                        @click="scroolTop" /></span>
            </transition>
        </div>
    </div>
</template>
<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import config from "../../common/config";
    import { Loading, Message } from "element-ui";
    import axios from "axios";
    import Jroll from "jroll";

    //获取搜索关键字
    let _title = /kw=([^\&\?]*)/g.exec(decodeURIComponent(window.location.hash));
    _title = _title && _title[1];

    var that = null;
    export default {
        data() {
            return {
                imgHost: config.PHPHOST,
                listRoll: "",
                backTopShow: false,
                productList: [],
                tabsName: [],
                tabIdx: 0,
                counts: "" || 0,
                loading: false,
                loadtips: "加载中...",
                totalPage: 0,
                queryStr: {
                    searchType: 0,
                    searchName: "",
                    pagesSize: 10,
                    page: 0,
                    id: 1,
                    cate: "",
                    cate2: "",
                    cate3: "",
                    cateName: "",
                    type: "",
                    category: "",
                },
                swiperOption: {
                    slidesPerView: 3.5,
                    freeMode: true,
                },
            };
        },
        components: {
            swiper,
            swiperSlide,
        },
        metaInfo: {
            titleTemplate: function () {
                let _title = /kw=([^\&\?]*)/g.exec(decodeURIComponent(window.location.hash));
                _title = _title && _title.length > 0 ? _title[1] : "";
                return _title
                    ? _title + "-优料库-化工原料&材料数据库"
                    : "优料库-化工原料&材料数据库";
            },
            meta: [
                {
                    name: "keywords",
                    content: ",优料库,配方,原材料,在线课堂,MSDS,TDS,产品手册,免费申请",
                },
                {
                    name: "description",
                    content:
                        "在线支持原料性能搜索,通过覆盖全球供应商的产品数据库资源,为用户提供数据查询、资料下载、在线培训和试样申请等专业信息服务。",
                },
            ],
        },
        created() {
            var type = this.$route.query.type;

            //console.log(type)
            this.queryStr.type = type;
            this.queryStr.cate = this.$route.query.cid1 || "";
            if (type == 2) {
                this.queryStr.cate2 = this.$route.query.cid2 || "";
            } else if (type == 3) {
                this.queryStr.cate2 = this.$route.query.cid2 || "";
                this.queryStr.cate3 = this.$route.query.cid3 || "";
            }
            this.queryStr.searchType = this.$route.query.fr;
            this.queryStr.searchName = decodeURIComponent(
                decodeURIComponent(this.$route.query.kw)
            );
            this.queryStr.cateName = this.$route.query.catename;
            this.queryStr.category = this.$route.query.category;
        },
        mounted() {
            _hmt.push(["_trackPageview", `/${window.location.hash}`]);
            WeChatShare({
                callback: () => {
                    var title = this.queryStr.searchName + "-优料库-化工原料&材料数据库",
                        desc =
                            "在线支持原料性能搜索,通过覆盖全球供应商的产品数据库资源,为用户提供数据查询、资料下载、在线培训和试样申请等专业信息服务。",
                        imgUrl = config.PHPHOST + "frontend/web/images/logo-new.jpg";

                    wx.onMenuShareAppMessage({
                        title: title,
                        desc: desc,
                        link: window.location.href,
                        imgUrl: imgUrl,
                    });
                    wx.onMenuShareTimeline({
                        title: title + " - " + desc,
                        link: window.location.href,
                        imgUrl: imgUrl,
                    });
                },
                data: "url=" + encodeURIComponent(window.location.href),
                url: config.MAPI,
            });

            window.addEventListener("scroll", this.handleScroll);
            this.getData();
        },
        updated() {
            //this.mySwiper.update();
        },
        destroyed() {
            window.removeEventListener("scroll", this.handleScroll);
        },
        methods: {
            showSwiperContent(val) {
                this.swiperActive = val;
            },
            handleScroll() {
                if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                    this.backTopShow = true;
                } else {
                    this.backTopShow = false;
                }
                if (this.loading) return;
                if (
                    document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 150 ||
                    document.body.scrollHeight -
                    document.documentElement.scrollTop -
                    window.innerHeight <
                    150
                ) {
                    this.loadmore();
                }
            },
            scroolTop() {
                window.scrollTo(0, 0);
            },
            getData() {
                let str = this.queryStr;
                axios
                    .get(config.PHPHOST + "api/web/index.php?r=product/list", { params: str })
                    .then(
                        function (res) {
                            if (res.data.flag == 0) {
                                if (res.data.data.className && res.data.data.className.length > 0) {
                                    this.tabsName = res.data.data.className;
                                }
                                this.productList = [...this.productList, ...res.data.data.product];
                                //this.productList.push.apply(this.productList,res.data.data.product);
                                this.counts = res.data.data.counts;
                                this.totalPage = Math.ceil(res.data.data.counts / 10);
                                if (this.totalPage <= 1) {
                                    this.loadtips = "没有更多数据了";
                                }

                                this.loading = false;
                            } else {
                                this.loadtips = "没有更多数据了";
                                Message({
                                    message: res.data.msg,
                                    showClose: false,
                                    customClass: "search-msg-style",
                                    duration: 2000,
                                });
                            }
                        }.bind(this)
                    );
            },
            loadmore() {
                this.loading = true;
                if (this.totalPage > this.queryStr.page) {
                    this.queryStr.page++;
                    this.getData();
                } else {
                    this.loadtips = "没有更多数据了";
                    return false;
                }
            },
            tabHandle(tabItemIndex, item) {
                if (this.tabIndex === tabItemIndex) return;
                this.tabIdx = tabItemIndex;
                this.queryStr.page = 0;
                this.queryStr.cate3 = tabItemIndex == 1 ? "182" : "";
                this.loadtips = "加载中...";
                this.productList = [];
                this.loading = false;
                this.getData();
            },
        },
    };
</script>
<style lang="less">

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .pg-product-list {
        header {
            background: #fff;
            width: 100%;
            z-index: 9;

            .toptitle {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                height: auto;
                padding: 1rem 0 !important;
                border-bottom: 1rem solid #f1f1f1;
            }

            h1 {
                font-size: 1.6rem;
                padding-left: 1rem;
                flex: 1 1;
                min-width: 9.6rem;
            }

            .header-right {
                flex: 1;
                text-align: right;
                padding-right: 1rem;
                font-size: 1.4rem;
                color: #666;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;

                em {
                    color: #0994ff;
                    font-weight: 600;
                }
            }
        }

        .tabs {
            height: 4rem;
            line-height: 4rem;
            border-bottom: 0.1rem solid #ddd;

            .swiper-slide {
                text-align: center;
            }

            a {
                color: #333;
                display: block;
                width: 70%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 0 auto;
            }

            a.active {
                color: #0994ff;
                border-bottom: 0.2rem solid #0994ff;
            }
        }

        .fixtab2 {}

        .list {
            ul {
                li {
                    a {
                        border-bottom: 0.1rem solid #e1e1e1;
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        display: flex;
                    }

                    .img-wrapper {
                        flex: none;
                        width: 7rem;
                        height: 7rem;
                        border: 0.1rem solid #ddd;
                        border-radius: 0.4rem;
                        margin: 1rem;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .item-right {
                        flex: 1;
                        padding-right: 3rem;
                        position: relative;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        &::after {
                            content: "";
                            position: absolute;
                            width: 2rem;
                            height: 100%;
                            right: 0;
                            top: 0;
                            background: url(../../assets/images/arrow-r.png) center no-repeat;
                            background-size: 0.7rem;
                        }

                        h3 {
                            width: 100%;
                            font-size: 1.5rem;
                            margin-top: 1rem;
                            line-height: 3rem;
                            font-weight: 400;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        p {
                            line-height: 2rem;
                            color: #999;
                            font-size: 1.3rem;
                        }
                    }
                }
            }
        }

        .ctrls {
            position: fixed;
            width: 3rem;
            height: 7rem;
            bottom: 6rem;
            right: 1rem;

            a,
            span {
                display: block;
                width: 3rem;
                height: 3rem;
                margin-bottom: 1rem;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .pl-header {
        position: fixed !important;
        background: #fff;
        width: 100%;
        z-index: 9;

        .toptitle {
            padding: 0 1rem !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/home/product-list.vue